const ISO_DATE_STRING_REGEX = /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/;
export function isIsoDateString(date) {
    return typeof date === 'string' && ISO_DATE_STRING_REGEX.test(date);
}
